import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();

    // Redirige vers la page de login après la déconnexion
    navigate("/login");
  }, [navigate]);

  return (
    <div>
      <h2>Déconnexion en cours...</h2>
    </div>
  );
}

export default Logout;
